import { ReactNode } from 'react';
import { cn } from '../../../../utils/cn';
import { LegendProps, DefaultLegendContentProps } from 'recharts';

export type ChartLegendContentProps = LegendProps &
  Pick<DefaultLegendContentProps, 'payload'>;

export const ChartLegendContent = (
  props: ChartLegendContentProps,
): ReactNode => {
  const {
    className,
    payload,
    verticalAlign = 'bottom',
    align = 'right',
    formatter,
  } = props;

  return (
    <div
      className={cn(
        'm-4 flex max-w-full flex-wrap justify-center gap-4',
        verticalAlign === 'top' ? 'pb-3' : 'pt-3',
        align !== 'center' ? 'flex-col' : 'flex-row',
        className,
      )}
    >
      {payload?.map((item, index) => {
        const renderValue = formatter
          ? formatter(item.value, item, index)
          : item.value;

        return (
          <div
            key={item.value}
            className="flex cursor-pointer items-center gap-1.5 rounded px-1 text-sm text-nowrap overflow-ellipsis text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800"
            onMouseEnter={(e) => {
              props.onMouseEnter?.(item, index, e);
            }}
            onMouseLeave={(e) => {
              props.onMouseLeave?.(item, index, e);
            }}
          >
            <div
              className="h-3 w-3 flex-shrink-0 truncate rounded border-2 border-gray-50 whitespace-pre drop-shadow"
              style={{
                backgroundColor: item.color,
              }}
            />
            {renderValue}
          </div>
        );
      })}
    </div>
  );
};
